<div class="swapSection" [ngClass]="{ 'mt-1': !isModal() }">
  @if (isModal()) {
  <div class="tabs d-flex gap-2 mb-3 justify-content-around">
    <button class="btn btn-white" [ngClass]="{ selected: !isWert() && activeToken.symbol === 'ETH' }"
      (click)="changeTab('ETH', 'ETH')">
      <img loading="lazy" src="/assets/images/svg-icons/ETH.svg" height="25" alt="ETH" class="eth-logo me-1" />
      <span>ETH</span>
    </button>
    <button class="btn btn-white" [ngClass]="{ selected: !isWert() && activeToken.symbol === 'USDT' }"
      (click)="changeTab('ETH', 'USDT')">
      <img loading="lazy" src="/assets/images/svg-icons/usdt.svg" height="25" alt="USDT" class="eth-logo me-1" />
      <span>USDT</span>
    </button>

    <button class="btn btn-white" [ngClass]="{ selected: !isWert && activeToken.symbol === 'USDC' }"
      (click)="changeTab('ETH', 'USDC')">
      <img loading="lazy" src="/assets/images/svg-icons/usdc.svg" height="25" alt="USDC" class="eth-logo me-1" />
      <span>USDC</span>
    </button>
    <button class="btn btn-white" [ngClass]="{ selected: !isNative() && isWert() }" (click)="cardMode()">
      <img loading="lazy" src="/assets/images/svg-icons/card.svg" height="26" alt="CARD" class="eth-logo me-1" />
      <span>{{ 'widget.card' | translate }}</span>
    </button>
  </div>
  }

  @if (walletAddress && isModal() && !isWert()) {
  <div class="text-center pb-2 font-16">
    <div class="ms-2 fw-semibold dashTitle text-white">{{ activeToken.symbol }} {{ 'balance' | translate }} {{
      convertNum(activeToken.tokenBalance, 4) }}</div>
  </div>
  }

  <!-- ====== not started ====== -->

  @if (status === SwapStatus.not_started) {
  <div class="body-section" [ngClass]="{ 'mt-0': isModal(), 'content-wrapper': !isModal() }">
    <div class="row">
      <div [ngClass]="{ 'col-12 col-xl-12': isWert() || isModal() }" class="col-7 col-xl-7 pe-xl-2">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="d-block font-11 text-white fw-bold">{{ 'widget.pay_with' | translate: { tokenName } }} </label>
          @if (!isWert()) {
          <div class="text-white fw-bold cursor-pointer font-11 text-uppercase text-decoration-underline"
            (click)="max()">
            {{ 'widget.max' | translate }}
          </div>
          }
        </div>
        <div class="amountField d-flex align-items-start">
          <input #swapIn type="text" appTwoDigitDecimalNumber [noDecimal]="isNative() ? 10 : 6"
            class="form-control text-truncate" placeholder="0" [(ngModel)]="swapToken"
            (ngModelChange)="swapTokenUpdate.next($event)" />
        </div>
      </div>
      @if (!isWert() && !isModal()) {
      <div class="col-5 col-xl-5 ps-3g-2 pe-xl-2 amountTypeDrp align-self-end mb-0 ms-0">
        @if (!isWert()) {
        <div class="mb-2 text-white text-end">
          <p class="font-11 mb-0 text-white fw-bold">{{ 'widget.balance' | translate }} = {{
            convertNum(activeToken.tokenBalance, 4) }}</p>
        </div>
        }
        <div class="align-self-end">
          <div class="dropdown eth-dropdown" dropdown (onHidden)="searchQuery = ''">
            <button class="btn mx-0 toggle-btn w-100" dropdownToggle #dropDownBtn>
              <div class="dropdown-item d-flex align-items-center justify-content-center px-auto">
                <img [src]="activeToken.image" [alt]="activeToken.symbol" loading="eager" class="eth-logo" />
                <span class="eth-name text-white mx-2 fw-bold">{{ activeToken.symbol }}</span>
                <span class="arrow-down">
                  <img src="/assets/images/svg-icons/angle-down.svg" alt="Down Arrow" loading="eager"
                    class="down-arrow" />
                </span>
              </div>
            </button>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu (click)="$event.stopPropagation()">
              <div class="text-center widget-title text-white mt-2">{{ 'widget.choose_method' | translate }}</div>
              <div class="tabs gap-1">
                <ng-container>
                  <button class="btn btn-secondary" (click)="setTab('ALL', $event, true); searchQuery = ''"
                    [class.active]="selectedTab === 'ALL'">
                    <span>All</span>
                  </button>
                  <button class="btn btn-secondary" (click)="setTab('ETH', $event, true)"
                    [class.active]="selectedTab === 'ETH'">
                    <img loading="lazy" src="/assets/images/svg-icons/ETH.svg" alt="ETH" class="eth-logo me-1" />
                    <span>ETH</span>
                  </button>
                  <button class="btn btn-secondary" (click)="setTab('BNB', $event, true)"
                    [class.active]="selectedTab === 'BNB'">
                    <img loading="lazy" src="/assets/images/svg-icons/BNB.svg" alt="BNB" class="eth-logo me-1" />
                    <span>BSC</span>
                  </button>
                  <button class="btn btn-secondary" (click)="setTab('SOL', $event, true)"
                    [class.active]="selectedTab === 'SOL'">
                    <img loading="lazy" src="/assets/images/svg-icons/SOL.svg" alt="SOL" class="eth-logo me-1" />
                    <span>SOL</span>
                  </button>
                  <button class="btn btn-secondary" (click)="setTab('POL', $event, true)"
                    [class.active]="selectedTab === 'POL'">
                    <img loading="lazy" src="/assets/images/svg-icons/polygon.svg" alt="POLY" class="eth-logo me-1" />
                    <span>POLY</span>
                  </button>
                  <button class="btn btn-secondary" (click)="setTab('ARB', $event, true)"
                    [class.active]="selectedTab === 'ARB'">
                    <img loading="lazy" src="/assets/images/svg-icons/arbitrum.svg" alt="BNB" class="eth-logo me-1" />
                    <span>ARB</span>
                  </button>

                  <!-- <button class="btn btn-secondary" (click)="setTab('SOL', $event, true)" [class.active]="selectedTab === 'SOL'">
                        <img loading="lazy" src="/assets/images/svg-icons/sol_sol.svg" alt="SOL" class="eth-logo me-1" />
                        <span>SOL</span>
                      </button> -->
                </ng-container>
              </div>
              @if (selectedTab === 'ALL') {
              <div class="search-input-wrapper">
                <input type="text" class="form-control form-control-sm search-input" placeholder="Search tokens..."
                  [(ngModel)]="searchQuery" />
                @if (searchQuery) {
                <button type="button" class="search-clear-btn" (click)="clearSearch()" title="Clear search">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </button>
                }
              </div>
              }
              <div class="itemHolder">
                @for (item of getDisplayTokens(); track item; let i = $index) {
                <div class="d-flex justify-content-between tab-cont-wrap"
                  [ngClass]="{ 'active-tab': activeToken.symbol === item.symbol && activeToken.category === item.category, 'no-bal': item.tokenBalance == 0, 'cursor-pointer': item.tokenBalance > 0 }"
                  (click)="item.tokenBalance > 0 ? setActiveTab(item) : $event.stopPropagation()">
                  <div class="d-flex">
                    <img [src]="item.image" alt="{{ item.otherSymbol || item.symbol }}" class="drop-logo"
                      loading="lazy" />
                    <div class="pt-2 ms-2 font-14">
                      <p class="mb-0">{{ item.name }}</p>
                      <p class="mb-2 font-14">{{ item.otherSymbol || item.symbol }}</p>
                    </div>
                  </div>
                  <div class="pt-2">
                    <p class="mb-0 me-0 text-end fw-normal font-12">~${{ convertNum(item.tokenUsdVal, 4) }}</p>
                    <p class="mb-2 me-0 text-end font-14">{{ convertNum(item.tokenBalance, 5) }}</p>
                  </div>
                </div>
                }
              </div>
              <ng-container>
                <p class="text-center my-2 font-13 text-white dashTitle">Or</p>
                <div class="d-flex gap-3">
                  <button type="button" class="btn btn-secondary w-50 mb-3 mx-auto" (click)="changeChain(true)">{{
                    'widget.buy_with_card' | translate }}</button>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      }
      <div class="col-12 col-xl-12 pe-xl-2 mt-2 mt-xl-2">
        <div class="d-flex align-items-center justify-content-between mb-1">
          <div class="d-flex align-items-center justify-content-start">
            <label class="d-block font-11 text-truncate text-white fw-bold">{{
              'widget.amount_in'
              | translate
              : {
              cryptoName,
              }
              }}</label>
            <img src="/assets/images/svg-icons/info-icon.svg" class="img-fluid ms-2 cursor-pointer" [popover]="pop"
              triggers="mouseenter:mouseout" placement="bottom" alt="Info Icon" loading="eager" />
            <!-- ===== template for add sol address popover ===== -->
            <ng-template #pop>
              <div class="popupHtml">{{ 'widget.you_receive_info' | translate }}</div>
            </ng-template>
          </div>
          <label class="d-block d-3g-none d-xl-block font-11 text-truncate text-white fw-bold">1 {{ cryptoName }} = ${{
            salePrice }}</label>
        </div>
        <div class="amountField">
          <input type="text" appTwoDigitDecimalNumber [noDecimal]="0" class="form-control text-truncate"
            [(ngModel)]="baseToken" min="minAmount" (ngModelChange)="baseTokenUpdate.next($event)" pattern="\d*"
            placeholder="0" />
          <div class="amountType">
            @if (isBonusActive && tierDetails && tierDetails.currentTier && tierDetails.currentTier.bonusPercent) {
            <span class="fw-semibold font-12 me-2 text-success mt-2">+{{ tierDetails.currentTier.bonusPercent }}% {{
              'widget.bonus' | translate }} ({{ tierDetails.currentTier.bonusTokens | number: '1.0-0' }} $SEERX)</span>
            }
            <svg-icon src="./assets/images/svg-icons/token.svg"
              [svgStyle]="{ 'width.px': 22, 'height.px': 22 }"></svg-icon>
          </div>
        </div>
      </div>
      @if (isBonusActive && tierDetails && tierDetails.nextTier) {
      <span class="text-success font-13 text-center mt-2 fw-regular">{{ 'widget.next_bonus' | translate: { extraTokens:
        tierDetails.nextTier.extraTokensNeeded | number: '1.0-0', bonusPercent: tierDetails.nextTier.bonusPercent }
        }}</span>
      }
      <!-- ----- low balance info and error section ----- -->
      <div class="w-100 p-0 text-center">
        @if (!isLowBalance && !isWert() && walletAddress) {
        <div class="lowBalance mt-2 mb-2 mb-0 text-grey font-12">
          {{ 'widget.gas_fees' | translate: { modeName: activeToken.category } }}
        </div>
        }
        @if (isNative() && isLowBalance && !isWert() && walletAddress) {
        <div class="lowBalance warning-message m-2 mb-0 text-grey font-12">
          {{ 'widget.low_gas_fees' | translate: { modeName: activeToken.category } }}
        </div>
        }
        @if (!isNative() && isLowBalance && !isWert() && walletAddress) {
        <div class="lowBalance warning-message m-2 mb-0 text-grey font-12">
          {{ lowGas ? ('widget.low_gas_fees' | translate: { modeName: activeToken.category }) : ('widget.low_usdt' |
          translate: { modeName: activeToken.symbol }) }}
        </div>
        }
        @if (baseToken && baseToken < minAmount && !isWert() && walletAddress) { <div
          class="text-center mt-2 w-100 text-warning font-12">
          {{ 'widget.min_crypto' | translate: { minAmount, cryptoName } }}
      </div>
      }
      <!-- <div class="text-center mt-2 w-100 text-warning font-12" *ngIf="baseToken && baseToken >= minAmount && isLowBalance && !isWert && walletAddress">
          {{ 'widget.swap_error' | translate: { gasFees, modeName: activeToken.category, tokenName: activeToken.symbol } }}
        </div> -->
    </div>
  </div>
</div>
}
@if (status === SwapStatus.not_started) {
<div class="body-section" [ngClass]="{ 'mt-0': isModal() }">
  <div class="row">
    <div class="d-flex flex-column align-items-center mt-2"
      [ngClass]="{ 'mt-3': isWert(), 'combined-btns': activeToken.category == 'ETH' && !isModal(), 'gap-2': activeToken.category !== 'ETH' }">
      @if (activeToken.category == 'ETH') {
      <button type="button" class="btn btn-primary w-100 mb-2"
        [disabled]="(isLowBalance && !isWert()) || !swapToken || swapToken == 0" (click)="confirm(true)">{{
        'staking.buy_stake_for' | translate }} {{ stakeApy }}% {{ 'staking.rewards' | translate }}</button>
      }
      @if (!isModal()) {
      <button type="button" class="btn btn-primary w-100"
        [disabled]="(isLowBalance && !isWert()) || !swapToken || swapToken == 0" (click)="confirm()">{{ 'widget.buy_now'
        | translate }}</button>
      }
    </div>
    @if (!isModal()) {
    <p class="change-text text-white fw-bold text-center mt-2">
      {{ (isWert() ? 'widget.pay_with_crypto_instead' : 'widget.pay_with_card_instead') | translate }}
      <span (click)="toggleWert()" class="clickable">{{ 'widget.click_here' | translate }}</span>
    </p>
    }
    @if (!isWert()) {
    <p class="font-14 text-center my-2">
      @if (activeToken.category == 'ETH' && walletAddress) {
      <a (click)="openEthBuyWidget()" [ngClass]="isModal() ? 'text-white' : 'text-white'"
        class="text-decoration-underline cursor-pointer">
        {{ 'widget.not_enough_eth' | translate }}
      </a>
      }
      @if (activeToken.category == 'BNB' && walletAddress) {
      <a class="text-decoration-underline cursor-pointer text-yellow" (click)="openEthBuyWidget(true)">
        {{ 'widget.not_enough_bnb' | translate }}
      </a>
      }
    </p>
    }
  </div>
</div>
}

<!-- ====== show loader ====== -->

@if (status === SwapStatus.in_progess) {
<div class="body-section mt-1 text-center" [ngClass]="{ 'mt-0': isModal(), 'content-wrapper mb-2': !isModal() }">
  <img src="./assets/images/svg-icons/token.svg" loading="lazy" alt="loading" class="statusIcon loading" />
  <div class="fw-normal fw-bold font-16 px-2 my-1 text-uppercase text-white text-center">{{
    'widget.transaction_in_progress' | translate }}</div>
  @if (!isStake) {
  <p class="fs-7 mb-1 text-white">{{ 'widget.transction_info' | translate: { baseToken: +(baseToken ?? 0) +
    (tierDetails.currentTier.bonusTokens ?? 0), cryptoName } }}</p>
  }
  @if (isStake) {
  <p class="fs-7 mb-1 text-white">{{ 'staking.transction_info_stake' | translate: { baseToken: +(baseToken ?? 0) +
    (tierDetails.currentTier.bonusTokens ?? 0) } }}</p>
  }
</div>
}

<!-- ====== show confirm ====== -->

@if (status === SwapStatus.confirm_pending) {
<div class="body-section mt-1 text-center" [ngClass]="{ 'mt-0': isModal(), 'content-wrapper mb-2': !isModal() }">
  <img src="./assets/images/svg-icons/token.svg" loading="lazy" alt="loading" class="statusIcon loading" />
  <div class="fw-semibold fs-6 my-1 text-uppercase text-center text-secondary text-white">{{ 'confirm' | translate }}
  </div>
  @if (!isStake) {
  <p class="fs-7 mb-1 text-white">{{ 'widget.waiting_confirm' | translate: { cryptoName, tokenName } }}</p>
  }
  @if (isStake) {
  <p class="fs-7 mb-1 text-white">{{ 'staking.waiting_confirm_stake' | translate }}</p>
  }
  @if (isStake) {
  <p class="fs-7 mb-1 text-white">{{ 'staking.waiting_confirm_stake_2' | translate }}</p>
  }
</div>
}
<!-- ====== show pending ====== -->

@if (status === SwapStatus.approval_pending) {
<div class="body-section mt-1 text-center" [ngClass]="{ 'mt-0': isModal(), 'content-wrapper mb-2': !isModal() }">
  <img src="./assets/images/svg-icons/token.svg" loading="lazy" alt="loading" class="statusIcon loading" />
  <div class="fw-semibold fs-6 my-1 text-uppercase text-secondary text-white">{{ 'widget.authorise' | translate }}</div>
  <p class="fs-7 mb-1 text-white">{{ 'widget.waiting_approve' | translate: { cryptoName, tokenName: activeToken.symbol }
    }}</p>
</div>
}

<!-- ====== show success/completed ====== -->

@if (status === SwapStatus.complete) {
<div class="body-section mt-1 text-center" [ngClass]="{ 'mt-0': isModal(), 'content-wrapper mb-2': !isModal() }">
  <img src="./assets/images/popup-icons/success.svg" loading="lazy" alt="complete" class="statusIcon" />
  <div class="fw-semibold fs-6 my-1 text-uppercase text-success text-center">{{ 'widget.transaction_success' | translate
    }}</div>
  @if (isStake) {
  <p class="fs-7 mb-1 text-white mb-lg-4">
    {{
    'staking.transction_info_stake_success'
    | translate
    : {
    baseToken: +(baseToken ?? 0) + (tierDetails.currentTier.bonusTokens ?? 0),
    }
    }}
  </p>
  }
  @if (!isStake) {
  <p class="fs-7 mb-1 text-white mb-lg-4">{{ 'widget.transction_info' | translate: { baseToken: +(baseToken ?? 0) +
    (tierDetails.currentTier.bonusTokens ?? 0), cryptoName } }}</p>
  }
  @if (modeName == 'ETH' && !isModal() && !isStake) {
  <div class="d-flex align-items-center justify-content-center">
    <button (click)="stakeNow()" class="btn btn-md mb-2 btn-primary w-100 fs-7 text-uppercase">{{ 'widget.stake_now' |
      translate }}</button>
  </div>
  }
  <div class="d-flex align-items-center justify-content-center gap-2">
    <button (click)="viewUrl()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.view_transaction' |
      translate }}</button>
    <button (click)="startAgain()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.start_again' | translate
      }}</button>
  </div>
</div>
}

<!-- ====== show failed ====== -->
@if (status === SwapStatus.failed) {
<div class="body-section mt-1 text-center" [ngClass]="{ 'mt-0': isModal(), 'content-wrapper mb-2': !isModal() }">
  <img src="./assets/images/popup-icons/warning.svg" loading="lazy" alt="failed" class="statusIcon" />
  <div class="fw-semibold fs-6 my-1 text-uppercase text-danger text-center">{{ 'widget.transaction_failed' | translate
    }}</div>
  <p class="fs-7 mb-1 mb-lg-4 text-danger">{{ 'widget.view_transaction_info' | translate }}</p>
  <div class="d-flex align-items-center justify-content-center gap-2">
    <button (click)="viewUrl()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.view_transaction' |
      translate }}</button>
    <button (click)="startAgain()" class="btn btn-primary w-50 fs-8 text-uppercase">{{ 'widget.start_again' | translate
      }}</button>
  </div>
</div>
}

<!-- ====== show rejected ====== -->

@if (status === SwapStatus.rejected) {
<div class="body-section mt-1 text-center" [ngClass]="{ 'mt-0': isModal(), 'content-wrapper mb-2': !isModal() }">
  <img src="./assets/images/popup-icons/warning.svg" loading="lazy" alt="failed" class="statusIcon" />
  <div class="fw-semibold fs-6 text-uppercase text-danger my-1 text-center">{{ 'widget.transaction_rejected' | translate
    }}</div>
  <div class="d-flex align-items-center justify-content-center gap-2 mt-3">
    <button (click)="startAgain()" class="btn btn-primary w-100 fs-7 text-uppercase">{{ 'widget.start_again' | translate
      }}</button>
  </div>
</div>
}
</div>